module.exports = {"id":"215086","name":"Brayan Cortés","rating":"71","photo":"./data/images/photos/3/215086.png","club":{"name":"Colo-Colo","logo":"./data/images/clubs/Colo-Colo.png"},"positions":["G"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BrayanCortes0.json
// module id = 643
// module chunks = 0